export default "__VITE_ASSET__f102b317__"